
<span
    ref="trigger"
    class="popover-trigger"
    :class="{ 'is-disabled': disabled }"
    :tabindex="disabled ? -1 : 0"
    @click.stop="handleClick"
>
    <slot name="trigger">
        <span ref="triggerNode" class="popover-default-trigger">
            <slot></slot>
        </span>
    </slot>
    <portal v-if="hasBeenOpened" to="overlay">
        <MorphingGhost
            :from-element="$refs.triggerNode || $refs.trigger"
            :to-element="$refs.popover"
            :is-open="visible"
            :speed="speed"
            @animation-complete="handleAnimationComplete"
        />
        <div
            v-show="visible"
            ref="popover"
            class="popover"
            :class="{ 'is-morphing': isMorphing }"
            :style="popoverStyle"
            @click.stop
        >
            <div class="popover-content" :class="{ 'is-content-hidden': !isContentVisible }">
                <slot name="content" :close="close">
                    <div class="popover-default-content">
                        <slot name="default"></slot>
                    </div>
                </slot>

                <div v-if="$slots.actions" class="popover-actions">
                    <slot name="actions" :close="close" />
                </div>
            </div>
        </div>
    </portal>
</span>
